import { useState } from 'react';
import './Admin.css';
import AdminLogin from './AdminLogin';
import AdminContacts from './AdminContacts';
import AdminPhotos from './AdminPhotos';
import AdminRdv from './AdminRdv';
import AdminDisponibilites from './AdminDisponibilites';

const NAV = [
  { key: 'contacts', label: 'Demandes contact', icon: '📋' },
  { key: 'photos', label: 'Photos', icon: '📸' },
  { key: 'rdv', label: 'Appels planifiés', icon: '📞' },
  { key: 'dispo', label: 'Disponibilités', icon: '📆' },
];

const AdminPage = () => {
  const [auth, setAuth] = useState(!!sessionStorage.getItem('admin_auth'));
  const [tab, setTab] = useState('contacts');

  if (!auth) return <AdminLogin onLogin={() => setAuth(true)} />;

  const logout = () => {
    sessionStorage.removeItem('admin_auth');
    setAuth(false);
  };

  return (
    <div className="admin-root">
      <div className="admin-layout">
        <aside className="admin-sidebar">
          <div className="admin-sidebar-logo">
            <img src="/logo-tram.png" alt="Logo" />
            <span><span className="t">Tram</span><span className="e">energie</span></span>
          </div>

          <nav className="admin-nav">
            <div style={{ fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#4b5563', padding: '0 16px 8px' }}>
              Administration
            </div>
            {NAV.map(item => (
              <button
                key={item.key}
                className={`admin-nav-item${tab === item.key ? ' active' : ''}`}
                onClick={() => setTab(item.key)}
              >
                <span className="admin-nav-icon">{item.icon}</span>
                {item.label}
              </button>
            ))}
          </nav>

          <div className="admin-sidebar-bottom">
            <a href="/" className="admin-logout-btn" style={{ textDecoration: 'none' }}>
              <span>🌐</span> Voir le site
            </a>
            <button className="admin-logout-btn" onClick={logout}>
              <span>🚪</span> Déconnexion
            </button>
          </div>
        </aside>

        <main className="admin-main">
          {tab === 'contacts' && <AdminContacts />}
          {tab === 'photos' && <AdminPhotos />}
          {tab === 'rdv' && <AdminRdv />}
          {tab === 'dispo' && <AdminDisponibilites />}
        </main>
      </div>
    </div>
  );
};

export default AdminPage;
